import { Module } from 'vuex';
import { RootState } from 'frontend/types';

interface AlwaysShowLlpsState {
  alwaysShowLlps: boolean;
}

const alwaysShowLlps: Module<AlwaysShowLlpsState, RootState> = {
  namespaced: true,
  state: {
    alwaysShowLlps: false,
  },
  mutations: {
    setValue(state: AlwaysShowLlpsState, data: { value: boolean }): void {
      state.alwaysShowLlps = data.value;
    },
  },
  actions: {},
};

export default alwaysShowLlps;
